// Import the RTK Query methods from the React-specific entry point
import { Paths } from './paths/paths';
import { apiSlice } from './apiSlice';
import { UltimateBeneficialOwner } from './response/UltimateBeneficialOwner';
import {
  NewUltimateBeneficialOwner,
  UpdateUltimateBeneficialOwner,
} from './request/UltimateBeneficialOwner';

export const ultimateBeneficialOwnerSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    ultimateBeneficialOwners: builder.query<UltimateBeneficialOwner[], void>({
      query: () => Paths.UltimateBeneficialOwner,
      providesTags: ['ubo'],
    }),
    createUBO: builder.mutation<
      UltimateBeneficialOwner,
      NewUltimateBeneficialOwner
    >({
      query: (data) => ({
        url: Paths.UltimateBeneficialOwner,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['ubo'],
    }),
    updateUBO: builder.mutation<
      UltimateBeneficialOwner,
      UpdateUltimateBeneficialOwner
    >({
      query: (data) => ({
        url: Paths.UltimateBeneficialOwner,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['ubo'],
    }),
    deleteUBO: builder.mutation<void, string>({
      query: (uboId) => ({
        url: Paths.UltimateBeneficialOwner,
        method: 'DELETE',
        params: { uboId },
      }),
      invalidatesTags: ['ubo'],
    }),
  }),
});

export const {
  useUltimateBeneficialOwnersQuery,
  useCreateUBOMutation,
  useUpdateUBOMutation,
  useDeleteUBOMutation,
} = ultimateBeneficialOwnerSlice;
